import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const statusColors = { not_started: 'secondary', in_progress: 'primary', completed: 'success' };
const statusLabels = { not_started: 'Not Started', in_progress: 'In Progress', completed: 'Completed' };

export default function Courses() {
  const { isSupervisor } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');

  useEffect(() => {
    api.get('/courses').then(r => setCourses(r.data.data)).finally(() => setLoading(false));
  }, []);

  const filtered = courses.filter(c => c.title.toLowerCase().includes(search.toLowerCase()));

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>;

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 className="fw-bold mb-1">Courses</h5>
          <p className="text-muted mb-0 small">{courses.length} course{courses.length !== 1 ? 's' : ''} available</p>
        </div>
        <div className="d-flex gap-2">
          <input className="form-control form-control-sm" placeholder="Search courses..." value={search} onChange={e => setSearch(e.target.value)} style={{width:200}} />
          {isSupervisor && <Link to="/course-builder" className="btn btn-primary btn-sm"><i className="bi bi-plus-lg me-1" />New Course</Link>}
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <i className="bi bi-book fs-1 d-block mb-3 opacity-25" />
          <p>No courses found</p>
        </div>
      ) : (
        <div className="row g-4">
          {filtered.map(course => (
            <div className="col-md-6 col-xl-4" key={course.id}>
              <div className="course-card h-100">
                <div className="card-header-custom">
                  <h6 className="mb-1 fw-bold">{course.title}</h6>
                  <small className="opacity-75">{course.description || 'No description'}</small>
                </div>
                <div className="p-3">
                  {!isSupervisor && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className={`status-badge badge bg-${statusColors[course.status]}`}>
                          {statusLabels[course.status] || 'Not Started'}
                        </span>
                        <span className="small text-muted">{course.progress_pct || 0}% complete</span>
                      </div>
                      <div className="progress mb-3" style={{height:6}}>
                        <div className="progress-bar bg-primary" style={{width: `${course.progress_pct || 0}%`}} />
                      </div>
                    </>
                  )}
                  {isSupervisor && (
                    <p className="small text-muted mb-3">
                      <i className="bi bi-people me-1" />{course.assigned_count || 0} employee{course.assigned_count !== 1 ? 's' : ''} assigned
                    </p>
                  )}
                  <div className="d-flex gap-2">
                    <Link to={`/courses/${course.id}`} className="btn btn-primary btn-sm flex-grow-1">
                      <i className="bi bi-arrow-right-circle me-1" />{isSupervisor ? 'Manage' : 'Continue'}
                    </Link>
                    {isSupervisor && (
                      <Link to={`/course-builder/${course.id}`} className="btn btn-outline-secondary btn-sm">
                        <i className="bi bi-pencil" />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
